<script>
import AppLayout from '@/components/layouts/AppLayout.vue';
import DebugRequestPanel from '@/views/DebugRequestPanel.vue';

export default {
    components: {
        AppLayout,
        DebugRequestPanel,
    }
};
</script>

<template>
    <AppLayout />

    <notifications
        width="400px"
        group="errors"
        classes="errors-notify vue-notification"
        position="top right" />

    <notifications
        width="400px"
        group="success"
        classes="success-notify vue-notification"
        position="top right" />

    <notifications
        width="600px"
        group="warning"
        classes="vue-notification"
        position="top right" />

    <DebugRequestPanel v-if="true" />
</template>